import axios from 'axios'
import UrlParse from 'url-parse'
import Download from 'downloadjs'

const THUMBOR_PARAMETERS_BACKGROUND = '/fit-in/800x800'
const THUMBOR_PARAMETERS_LOGO = '/fit-in/256x256'

const state = {

}

const mutations = {

}

const actions = {
  async upload (context, { type, extra = {}, data }) {
    const url = await context.dispatch('graphqlQuery', {
      name: 'getPresignedUploadUrl',
      variables: {
        type,
        extra
      },
      ignoreCache: true
    }, { root: true })

    if (!url) throw new Error('did not get valid presigned url: ' + url)

    await axios({
      method: 'PUT',
      url,
      data
    })

    const parsedUrl = UrlParse(url)

    let thumborUrl = process.env.VUE_APP_FORMSETTINGS_PREFIX_URL

    if (type === 'form_background') {
      return thumborUrl + `${THUMBOR_PARAMETERS_BACKGROUND}${parsedUrl.pathname}`
    } else if (type === 'form_logo') {
      return thumborUrl + `${THUMBOR_PARAMETERS_LOGO}${parsedUrl.pathname}`
    } else {
      return parsedUrl.origin + parsedUrl.pathname
    }
  },

  async download (context, { url, name }) {
    var x = new XMLHttpRequest()
    x.open('GET', url, true)
    x.responseType = 'blob'
    x.onload = (e) => Download(e.target.response, name)
    x.send()
  },

  async downloadBase64 (context, { base64, name, fileType }) {
    Download(base64, name, fileType)
  }
}

const getters = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
